import { render, staticRenderFns } from "./FaceScannerPageTemplate.vue?vue&type=template&id=0db831e2"
import script from "./FaceScannerPageTemplate.vue?vue&type=script&lang=js"
export * from "./FaceScannerPageTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports